"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");
/**
 * Formats the output of a received post message
 *
 * @method outputPostFormatter
 * @param {Object}
 * @returns {Object}
 */


function outputPostFormatter(post) {
  post.expiry = utils_1.hexToNumber(post.expiry);
  post.sent = utils_1.hexToNumber(post.sent);
  post.ttl = utils_1.hexToNumber(post.ttl);
  post.workProved = utils_1.hexToNumber(post.workProved); // post.payloadRaw = post.payload;
  // post.payload = utils.hexToAscii(post.payload);
  // if (utils.isJson(post.payload)) {
  //     post.payload = JSON.parse(post.payload);
  // }
  // format the following options

  if (!post.topics) {
    post.topics = [];
  }

  post.topics = post.topics.map(function (topic) {
    return utils_1.hexToUtf8(topic);
  });
  return post;
}

exports.outputPostFormatter = outputPostFormatter;